<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-nav">
      <div class="header-nav-wrapper">
        <!-- 导航内容 -->
        <ul class="nav-ul">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="header-nav-rigth inputDeep">
          <div
            class="header-txt"
            v-if="!$store.state.token || !$store.getters.userInfo"
          >
            <span @click="jump('/login', '1')">{{ $t("Login") }}</span
            ><span @click="jump('/login', '0')">{{ $t("Register") }}</span>
          </div>
          <el-button
            type="text"
            slot="reference"
            @click="updateIcon"
            v-if="$store.state.token && $store.getters.userInfo"
            >{{
              `${$t("Hello,")}
                        ${
                          $store.getters.userInfo.nickname
                            ? $store.getters.userInfo.nickname
                            : $store.getters.userInfo.mobile
                        } `
            }}
            <i :class="elIcon"></i
          ></el-button>
          <el-popover
            placement="bottom"
            width="103"
            trigger="click"
            visible-arrow:true
            offset="100px"
            v-model="showPopover"
            ref="popover"
          >
            <ul class="headMenu">
              <li
                v-for="(item, index) in headMenu"
                :key="index"
                @click="jump(item.path)"
              >
                {{ item.name }}
              </li>
            </ul>
          </el-popover>
          <!-- <span style="padding-left: 20px;">Language</span> -->
          <language-select style="display: inline-block"></language-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import languageSelect from "@/components/common/languageSelect";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 1,
      menuName: "",
      menuClass: "glyphicon glyphicon-menu-down",
      showPopover: false,
      elIcon: "el-icon-caret-top"
    };
  },
  components: {
    languageSelect
  },
  methods: {
    updateIcon() {
      if (this.elIcon == "el-icon-caret-top") {
        this.elIcon = "el-icon-caret-bottom";
        //点击隐藏
        this.showPopover = true;
      } else {
        this.elIcon = "el-icon-caret-top";
        //点击显示
        this.showPopover = false;
      }
    },
    updateInternationalize() {
      if (this.elInternationalizeIcon == "el-icon-caret-top") {
        this.elInternationalizeIcon = "el-icon-caret-bottom";
        //点击隐藏
        this.showInternationalize = true;
      } else {
        this.elInternationalizeIcon = "el-icon-caret-top";
        //点击显示
        this.showInternationalize = false;
      }
    },

    navClick(index, item) {
      this.$store.commit("routeName", item.path);
      if (item.path == "/help") {
        if (this.$store.getters.globalConfig.language == "zh_CN") {
          window.open("https://www.yuque.com/zhixuejun/llas6w");
        } else {
          window.open("https://www.yuque.com/zhixuejun/fddgww");
        }
      } else {
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
        this.menuName = item.name;
        this.$router.push({ path: item.path });
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    jump(path, query) {
      if (query) {
        this.$router.push({
          path: path,
          query: { type: query }
        });
      } else {
        if (path == "/login") {
          this.$store.dispatch("cleanUser");
        } else {
          this.elIcon = "el-icon-caret-top";
          //点击隐藏
          this.showPopover = false;
        }
        this.$router.push({
          path: path
        });
      }
    }
  },
  computed: {
    headMenu() {
      let orgManageInfo = this.$store.getters.orgInfo.orgManager
      if (this.$store.getters.routeName == "/dictation") {
        return [
          { name: this.$t("Profile"), path: "/dictation/user/profile/home" },
          {
            name: this.$t("我的收藏"),
            path: "/dictation/user/collection/album"
          },
          {
            name: this.$t("收费会员"),
            path: "/dictation/user/premium/dictationVip"
          },
          { name: this.$t("系统设置"), path: "/dictation/user/setting" }
        ];
      } else if (orgManageInfo && Object.keys(orgManageInfo).length != 0) {
        return [
          { name: this.$t("Profile"), path: "/toefl/user/profile/Home" },
          { name: this.$t("Active VIP"), path: "/toefl/user/premium/toeflPre" },
          {
            name: this.$t("Test Results"),
            path: "/toefl/user/testResults/setsOfExams"
          },
          {
            name: this.$t("Wrong Bookmark"),
            path: "/toefl/user/wrong/wrongQuestionbank"
          },
          { name: this.$t("Settings"), path: "/toefl/user/setting" },
          { name: this.$t("机构管理"), path: "/manage" },
          { name: this.$t("Logout"), path: "/login" }
        ];
      } else {
        return [
          { name: this.$t("Profile"), path: "/toefl/user/profile/Home" },
          { name: this.$t("Active VIP"), path: "/toefl/user/premium/toeflPre" },
          {
            name: this.$t("Test Results"),
            path: "/toefl/user/testResults/setsOfExams"
          },
          {
            name: this.$t("Wrong Bookmark"),
            path: "/toefl/user/wrong/wrongQuestionbank"
          },
          { name: this.$t("Settings"), path: "/toefl/user/setting" },
          { name: this.$t("Logout"), path: "/login" }
        ];
      }
    },
    navList() {
      return [
        {
          name: this.$t("Home"),
          path: "/main",
          children: []
        },
        {
          name: this.$t("TOEFL"),
          path: "/index"
        },
        // {
        //   name: this.$t("dictationAndReading"),
        //   path: "/dictation",
        // },
        // {
        //   name: "GRE",
        //   path: "/gre",
        //   children: [],
        // },
        // {
        //   name: "GMAT",
        //   path: "/",
        // },
        // {
        //   name: this.$t("IELTS"),
        //   path: "/",
        //   children: [],
        // },
        {
          name: this.$t("VIP"),
          path: "/vip",
          children: []
        },
        {
          name: this.$t("CustomerServices"),
          path: "/vip/customerService",
          children: []
        },
        {
          name: this.$t("help"),
          path: "/help",
          children: []
        }
        // {
        //   name: this.$t("Download"),
        //   path: "/login",
        //   children: [],
        // },
      ];
    }
  },
  created() {
    this.$i18n.locale = this.$store.state.globalConfig.language;
  }
};
</script>
<style lang="scss" scoped>
/* 顶部 */
#header {
  min-width: 1202px;
  transition: all ease 0.6s;
  // box-shadow: 0px 0px 10px 0px rgba(44, 63, 85, 0.2);
  box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 0.3);
  background: #fff;
  .header-top {
    height: 50px;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    background: #474747;

    span {
      margin: 0 8px;
    }
  }

  /* 导航栏 */
  .header-nav {
    height: 40px;
    width: 1202px;
    font-size: 12px;
    //box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 0.3);
    margin: auto;
    background: #fff;
    .header-nav-wrapper {
      overflow: hidden;
      margin: auto;
      width: 1202px;
      background: #fff;
    }

    .header-nav-rigth {
      color: #7b8b8e;
      font-size: 12px;
      line-height: 40px;
      float: right;

      .el-button--text {
        font-weight: 400;
        color: #7b8b8e;
      }

      .header-txt {
        display: inline-block;

        span {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }

    /* 导航栏 每个导航 */
    .header-nav-wrapper {
      .nav-ul {
        line-height: 40px;
        float: left;
        width: 600px;

        li {
          float: left;
          margin: 0 15px;
          position: relative;
          color: #7b8b8e;
          cursor: pointer;

          &.active {
            color: #384047;
            height: 24px;
            background: #7b8b8e;
            border-radius: 12px;
            margin-top: 8px;
            line-height: 24px;
            text-align: center;

            /* border-bottom: 2px solid #1e73be; */
            &:nth-child(1) {
              margin-left: 0;
            }
          }

          dl {
            display: none;
            position: absolute;
            width: 168px;
            top: 80%;
            left: 0;
            z-index: 999999;
            box-shadow: 0 0 3px 1px #ccc;
            background: #fff;
            display: block;

            dt {
              width: 100%;
              padding: 10px;
              border-bottom: 1px solid #ccc;

              &:hover {
                cursor: pointer;
                background: #ccc;
              }

              a:hover {
                text-decoration: none;
              }
            }
          }
        }
      }

      a {
        color: #7b8b8e;
        font-size: 12px;
        padding: 15px 0;
        position: relative;

        &:hover {
          color: #384047;
          text-decoration: none;

          .underline {
            opacity: 1;
            width: 100%;
            left: 0;
          }

          span {
            transform: rotate(180deg);
          }
        }

        i {
          display: block;
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          opacity: 0;
          transition: all 0.6s ease;
          background-color: #1e73be;
        }

        span {
          font-size: 12px;
          transition: transform ease 0.5s;
        }
      }
    }
  }

  .headMenu {
    font-size: 14px;
    font-weight: 400;
    color: #7b8b8e;

    li {
      text-align: center;
      width: 100%;
      height: 32px;
      line-height: 32px;
      cursor: pointer;

      &:hover {
        color: #5fcf80;
      }
    }
  }
}

// @media screen and (max-width: 997px) {
//   #header .header-nav-m {
//     position: relative;
//   }
//   /* 导航栏logo容器 */
//   #header .header-nav-m .header-nav-m-logo {
//     height: 80px;
//     position: relative;
//   }
//   /* 导航栏logo图片 */
//   #header .header-nav-m .header-nav-m-logo img {
//     width: 95px;
//     height: 45px;
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     margin: auto;
//   }
//   /* 导航栏  菜单容器 */
//   #header .header-nav-m .header-nav-m-menu {
//     color: #fff;
//     height: 50px;
//     font-size: 20px;
//     line-height: 50px;
//     background: #474747;
//     position: relative;
//   }
//   /* 导航栏 菜单图标 */
//   #header .header-nav-m .header-nav-m-menu-wrapper {
//     position: absolute;
//     top: 50%;
//     right: 20px;
//     margin-top: -20px;
//     width: 50px;
//     height: 40px;
//     color: #fff;
//     z-index: 999999;
//     font-size: 12px;
//   }
//   /* 导航栏 */
//   #header .header-nav-m .header-nav-m-wrapper {
//     position: absolute;
//     top: 50px;
//     left: 0;
//     width: 100%;
//     background: #474747;
//     z-index: 9999999;
//   }
//   /* 导航栏 每个导航 */
//   #header .header-nav-m .header-nav-m-wrapper > li {
//     height: 40px;
//     line-height: 40px;
//     border-bottom: 1px solid #ccc;
//   }
//   /* 导航栏 每个导航下面的 a 链接 */
//   #header .header-nav-m .header-nav-m-wrapper > li > a {
//     color: #fff;
//     font-size: 15px;
//     font-weight: bold;
//     padding: 15px 0;
//     position: relative;
//   }
//   /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
//   #header .header-nav .header-nav-wrapper > li > a > span {
//     font-size: 10px;
//   }
// }
/deep/ .el-select .el-input__inner {
  box-shadow: none !important;
  border: none !important;
  color: #7b8b8e;
  font-weight: 400;
}

/deep/ .el-select .el-icon-arrow-up:before {
  content: "\E78F";
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue